import Vue from 'vue';
import Vuex from 'vuex';

import getters from './getters';
import mutations from './mutations';
import actions from './actions';

Vue.config.devtools = true;
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    collectionProducts: [],
    mainCollection: {},
    mainProducts: [],
    addonProducts: [],
    cardProducts: [],
    defaultProducts: [],
    selectedAddonProducts: [],
    feeProduct: null,
    selectedSort: "1",
    selectedSortMobile: "1",
    selectedOccasion: ["View All"],
    selectedOccasionMobile: ["View All"],
    rangePrice: {min:0,max:100},
    rangePriceMobile: {min:0,max:100},
    selectedProduct: null,
    isLoading: true,
    categoriesList: [],
    selectedBox: {id:0},
  },
  getters,
  mutations,
  actions,
});

export default store;
